import React, { useState, useEffect } from "react";
import Logo from "../assets/images/Logo_2.png";
import "../style/home.css";
import { Link } from "react-router-dom";
import about from "../assets/images/about.jpeg";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import { useSelector } from "react-redux";
function Home() {

    const conect = collection(db, "Visiteors");
    const [opinion, setOpinion] = useState([]);
    const mode= useSelector(state=>state.Theme)
const[isDark,setMode]=useState();
useEffect(()=>{
    setMode(mode)
},[mode])
    const getOpinions = async () => {
        const data = await getDocs(conect);
        setOpinion(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    const arr = ["Front-End Developer"];
    const [displayText, setDisplayText] = useState("");
    let index = 0;
    let forward = true;
    const speed = 150;

    useEffect(() => {
        const interval = setInterval(() => {
            setDisplayText(arr[0].slice(0, index));
            if (forward) {
                index++;
                if (index > arr[0].length) {
                    forward = false;
                    setTimeout(() => {
                        index--;
                    }, 1000);
                }
            } else {
                index--;
                if (index === 0) {
                    forward = true;
                }
            }
        }, speed);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getOpinions();
    }, []);

    return (
        <div className={`${isDark&&"dark"}`}>
            <div className="main w-screen  dark:bg-slate-800 overflow-hidden ">
                <div className="content dark:bg-gradient-to-r dark:from-gray-800 dark:to-gray-400  mt-14 w-screen ">
                    <div className="left">
                        <div className="translate-x-10 max-[415px]:translate-x-1  w-96 absolute max-[350px]:top-20 top-40">
                            <p className="text-creamy font-medium text-4xl font-mono">My Name Is</p>
                            <h2 className="text-3xl max-[415px]:text-xl text-creamy font-serif  w-80 font-bold">Mahmud AL-Zhrawy</h2>
                            <div className="Text mt-2 dark:bg-slate-300  bg-creamy rounded-md h-14 max-[466px]:w-48 max-[466px]:h-20  w-96">
                                <p className="text-3xl ml-2 font-serif text-darkblue font-semibold py-2">{displayText}</p>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <img className=" max-[850px]:invisible mx-auto rounded-full max-[913px]:translate-x-64 translate-x-96" src={Logo} alt="Not Found" />
                    </div>
                </div>
                <div className="container dark:bg-slate-800 mt-3 mx-auto mb-6">
                    <div className="about mx-auto shadow-lg hover:scale-95 duration-700 ease-in-out dark:bg-slate-900 bg-blue-200 pb-12 px-8 relative my-5">
                        <h1 className="text-5xl text-gray-100 text-center font-serif font-extrabold">About</h1>
                        <div className="aboutContent">
                            <img className="w-48 h-48" src={about} alt="Not Found" />
                            <p className="font-mono text-cyan-700 font-bold max-[400px]:text-base max-[500px]:text-lg text-2xl">Hi i am Mahmud Nagi, a 3rd year student at faculty of Computers and Information in Assiut University, and studying at Computer science department. While studying at the faculty, I am also studying Front-end track. To read more about me click</p>
                        </div>
                        <Link to="/About" className="btn absolute right-0 mr-5 bottom-0.5">SHOW MORE ABOUT</Link>
                    </div>
                    <div className="work shadow-lg hover:scale-95 duration-700 ease-in-out dark:bg-slate-900 bg-blue-200 pb-12 px-8 relative my-5">
                        <h1 className="text-5xl text-gray-100 text-center font-serif font-extrabold">My Work</h1>
                        <div className="workContent">
                            <img className="w-48 h-48" src={Logo} alt="Not Found" />
                            <p className="font-mono font-bold text-cyan-700  max-[400px]:text-base max-[500px]:text-lg text-2xl">Here we will show our work and the last updates about my work. Without speaking a lot, come to see what I have already done.</p>
                        </div>
                        <Link to="/WorksPage" className="btn absolute right-0 bottom-0.5 mr-5">SHOW MY WORK</Link>
                    </div>
                </div>
                <div className="container mx-auto dark:bg-slate-900 bg-blue-500">
                    <div className="opinions h-96 overflow-scroll w-5/6 mx-auto dark:bg-slate-400 bg-white">
                        <h2 className="text-5xl font-serif font-extrabold text-blue-950 text-center my-5">pepole Opinions</h2>
                        {opinion.length > 0 ? (
                            <>
                                {opinion.map((opin) => {
                                    return (
                                        <div key={opin.id} className="opin relative w-4/5 mx-auto py-9 p-6 mb-8 rounded-lg dark:bg-slate-900 bg-blue-400">
                                            <p className="border rounded-lg absolute top-1 left-0 bg-creamy text-blue-900 font-bold  px-2 py-1">{opin.userName}</p>
                                            <p className="mt-4 text-white font-bold font-serif">{opin.userMessage}</p>
                                        </div>
                                    );
                                })}
                            </>
                        ) : (
                            <h2 className="text-5xl font-serif font-extrabold text-blue-700 text-center my-5">the opinion List is empity</h2>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
